import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./nav-menu.css";
import { Link } from "react-router-dom";
import portalLogo from "../../assets/images/portal-logo.png";
import NotifyLogo from "../../assets/images/notify-logo.png";
import Support from "../account/Support";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import { usePortalAuthentication } from "../../services/authorizationService";

const NavMenu = () => {
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const {
    userRole,
    setSearchObj,
    SetSharedObject,
    userSession,
    userToken,
    sharedObject,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    setSearchObj: state.setSearchObj,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
    userToken: state.userToken,
    sharedObject: state.sharedObject,
  }));
  const [processing, SetProcessing] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const [errMsg, setErrMsg] = useState(
    "Email purpose cannot be updated at this time. Please contact customer support for further assistance."
  );
  const userNameDisplay = userSession.preferred_username?.split("|")[0];
  const { logout } = usePortalAuthentication();

  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
  }, [flag, navigate]);
  function isEmpty(value) {
    return (
      value == null || (typeof value === "string" && value.trim().length === 0)
    );
  }

  const messageStatus = async () => {
    setFlag("/message-status");
  };
  return (
    <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light border-bottom  custom-navbar">
      <div className="container w-max2">
        <img src={portalLogo} title="Portal" alt="Portal Logo" />
        {/* Hamburger Menu*/}
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target=".navbar-collapse"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Main Menu Begins */}
        <div className="navbar-collapse collapse d-sm-inline-flex">
          <ul className="navbar-nav flex-grow">
            {userRole !== "SES ADMINISTRATOR" ? (
              <div>
                {sharedObject.getUserEmails &&
                sharedObject.getUserEmails.length > 0 ? (
                  <li className="nav-item">
                    <Link
                      onClick={(el) => {
                        if (window !== "undefined")
                          window.open("../webmail", "_self");
                      }}
                      className="nav-link text-light"
                    >
                      <i
                        className="bi bi-envelope-at-fill sp-margin5 respond-2"
                        alt="webmail icon"
                        title="Webmail"
                      ></i>
                      <span className="respond-1">Webmail</span>
                    </Link>
                  </li>
                ) : (
                  <li className="nav-item">
                    <Link
                      to={"/no-direct-email"}
                      className="nav-link text-light"
                    >
                      <i
                        className="bi bi-envelope-at-fill sp-margin5 respond-2"
                        alt="webmail icon"
                        title="Webmail"
                      ></i>
                      <span className="respond-1">Webmail</span>
                    </Link>
                  </li>
                )}
              </div>
            ) : null}
            {userRole !== "SES ADMINISTRATOR" ? (
              <div>
                {sharedObject.getUserEmails &&
                sharedObject.getUserEmails.length > 0 ? (
                  <li className="nav-item">
                    <Link
                      onClick={(el) => {
                        SetSharedObject("recievedMessageStatusResults", {});
                        messageStatus(el);
                      }}
                      className="nav-link text-light"
                    >
                      <i
                        className="bi bi-send-check sp-margin5 respond-2"
                        alt="sent message icon"
                        title="Message Status"
                      ></i>
                      <span className="respond-1">Message Status</span>
                    </Link>
                  </li>
                ) : null}
              </div>
            ) : null}
            <li className="nav-item">
              <Link
                className="nav-link text-light"
                onClick={(el) => {
                  setFlag("/directory-search");
                  SetSharedObject("AdvSearchObj", null);
                }}
              >
                <i
                  className="bi bi-folder sp-margin5 respond-2"
                  alt="folder icon"
                  title="Directory Search"
                ></i>
                <span className="respond-1">Directory Search</span>
              </Link>
            </li>
            {userSession.HasNotify === true && userRole === "ADMINISTRATOR" ? (
              <div>
                <li className="nav-item">
                  <Link to="/notify-app" className="nav-link text-light">
                    <img
                      src={NotifyLogo}
                      className="w-s respond-2"
                      alt="Notify icon"
                      title="Notify"
                    />
                    <span className="respond-1">Notify</span>
                  </Link>
                </li>
              </div>
            ) : null}
          </ul>
        </div>

        {/* User account menu on the right */}
        <div className="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse">
          <ul className="navbar-nav flex-grow">
            <li className="nav-item dropdown">
              <a
                className="nav-link text-light dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i
                  className="bi bi-person-circle sp-margin5"
                  alt="User Icon"
                  title="Username"
                ></i>
                <span className="admin-nav2">{userNameDisplay}</span>
              </a>
              <div
                className="dropdown-menu  shade-1"
                aria-labelledby="navbarDropdown"
              >
                <Link
                  className="dropdown-item"
                  data-toggle="modal"
                  onClick={(el) => {
                    setSearchObj([]);
                    SetSharedObject("accountDetailsFlag", true);
                    $("#detailsMemberUserModal").modal("show");
                  }}
                >
                  Account
                </Link>

                <Link
                  className="dropdown-item"
                  onClick={(el) => {
                    SetSharedObject("changePasswordFlag", true);
                    SetSharedObject("ResetPasswordId", userSession.sesuser_id);
                    setFlag("/change-password");
                  }}
                >
                  Change Password
                </Link>
              </div>
            </li>
            <li className="nav-item">
              <a
                href=""
                className="nav-link text-light"
                data-target="#contactInfoModal"
                data-toggle="modal"
              >
                <i
                  className="bi bi-headset sp-margin5"
                  alt="Customer Support Icon"
                  title="Support"
                ></i>
                <span className="admin-nav2">Support</span>
              </a>
              <Support />
            </li>
            <li className="nav-item">
              <Link
                onClick={(el) => {
                  el.preventDefault();
                  logout();
                }}
                className="nav-link text-light"
              >
                <i
                  className="bi bi-box-arrow-right sp-margin5"
                  alt="Sign Out Icon"
                  title="Sign Out"
                ></i>
                <span className="admin-nav2">Sign Out</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
      {successFlag ? (
        <div className="alert alert-danger" role="alert">
          {errMsg}
        </div>
      ) : null}
    </nav>
  );
};
export default NavMenu;
